var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.empty),expression:"!empty"}],staticClass:"m-operate flex-between-center",attrs:{"empty":_vm.empty,"border":_vm.border}},[_c('div',{staticClass:"m-operate-group flex-center-cross"},[_vm._t("default")],2),_c('div',{staticClass:"m-operate-group flex-center-cross"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }